import { User } from "@/models/auth.model";
import { Match } from "@/models/match.model";
import { ILSPermissions } from "@/models/permissions.model";

export function canNavigateToMatchEdit(user: User, match: Match): boolean {
  const captainIds = [match.hometeam.captain_id, match.awayteam.captain_id];
  const ownerIds = [match.hometeam.owner_id, match.awayteam.owner_id];
  const refereeIds = match.referees.map(referee => referee.user_id);
  const eventRefereeIds = match.event_referees.map(referee => referee.user_id);
  const hasAdminEventsRefereeAdminPermission = user.permissions.includes(ILSPermissions.AdminEventsRefereeAdmin);

  return (
    captainIds.includes(user.id) ||
    ownerIds.includes(user.id) ||
    refereeIds.includes(user.id) ||
    eventRefereeIds.includes(user.id) ||
    hasAdminEventsRefereeAdminPermission
  );
}
